import { render, staticRenderFns } from "./CommunityQnaDetail.vue?vue&type=template&id=af9ea0a8&scoped=true&"
import script from "./CommunityQnaDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityQnaDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityQnaDetail.vue?vue&type=style&index=0&id=af9ea0a8&scoped=true&lang=css&"
import style1 from "./CommunityQnaDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9ea0a8",
  null
  
)

export default component.exports